module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i3no2"))).then(() => parcelRequire('73N7L'));